import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { NavLink, useMatch, useNavigate } from "react-router-dom"
import { Box, styled } from "@mui/material"

import { useAppDispatch } from "redux/hooks"
import { SubscriptionContext } from "redux/contexts/subscription"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"
import Button from "components/ui/Button"
import {
  CLIENT_PROFILE_MATCH,
  CLIENT_SUBSCRIPTIONS_MATCH,
  // CLIENT_INVOICES_MATCH,
  SUBSCRIPTION_CREATE_MATCH,
} from "config"
import { colors } from "theme"

const ProfileNavigationComponent = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const {
    allowSubscribe,
    subscription: { eligible },
  } = useContext(SubscriptionContext)

  const isSubscriptionMatch = useMatch(CLIENT_SUBSCRIPTIONS_MATCH)

  const ITEMS = eligible
    ? [
        {
          link: CLIENT_PROFILE_MATCH,
          title: t("nav.profile"),
        },
        {
          link: CLIENT_SUBSCRIPTIONS_MATCH,
          title: t("nav.subscription"),
        },
        // TODO: use settings to show/hide components
        // {
        //   link: CLIENT_INVOICES_MATCH,
        //   title: t("nav.invoices"),
        // },
      ]
    : [
        {
          link: CLIENT_PROFILE_MATCH,
          title: t("nav.profile"),
        },
        // TODO: use settings to show/hide components
        // {
        //   link: CLIENT_INVOICES_MATCH,
        //   title: t("nav.invoices"),
        // },
      ]

  const handleResetPoling = () => {
    dispatch(resetPolling())
  }

  const openSubscriptionNewModal = () => {
    navigate(SUBSCRIPTION_CREATE_MATCH)
  }

  return (
    <Container>
      <>
        <Nav>
          {ITEMS.map(({ link, title }, index: number) => (
            <NavItem onClick={handleResetPoling} key={index} to={link}>
              {title}
            </NavItem>
          ))}
        </Nav>
        {allowSubscribe && isSubscriptionMatch && (
          <Subscribe onClick={openSubscriptionNewModal}>
            {t("features.subscription.actions.subscribe.title")}
          </Subscribe>
        )}
      </>
    </Container>
  )
}

export default ProfileNavigationComponent

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "0",
  [theme.breakpoints.down("md")]: {
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
  [theme.breakpoints.down("sm")]: {
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
}))

const Nav = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  margin: "0",
  [theme.breakpoints.down("md")]: {
    justifyContent: "space-around",
  },
  [theme.breakpoints.down("sm")]: {
    justifyContent: "space-between",
  },
}))

const NavItem = styled(NavLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  borderRadius: "21px",
  fontSize: "0.875rem",
  fontWeight: "500",
  lineHeight: "18px",
  height: "34px",
  padding: "7.25px 21px",
  textDecoration: "none",
  "&.active": {
    backgroundColor: colors.lightPersianGreen,
    fontWeight: "600",
  },
  [theme.breakpoints.down("md")]: {
    padding: "7.25px 11px",
  },
}))

export const Subscribe = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "34px",
  padding: "0 20px",
  width: "175px",
  [theme.breakpoints.down("md")]: {
    width: "120px",
  },
}))
